import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Card, CardContent } from 'base-ui'

import {
  ProductCopyVoucherButton,
  ProductVoucherInteractiveLabel,
} from '../../../../product'
import { useProductPageContext } from '../../productPageContext'

const VOUCHER_SECTION_ID = 'buybox-voucher-section'

export const ProductBuyBoxVoucherInfoProduct: FC = () => {
  const { product } = useProductPageContext()

  const ctaText = product.voucher_phrase ?? ''
  const legalText = product.voucher_claim ?? ''
  const voucher = product.voucher_code ?? ''

  if (!voucher) {
    return null
  }

  return (
    <section
      aria-labelledby={VOUCHER_SECTION_ID}
      className="border-t border-dark-primary-min pt-2.5"
    >
      <h3
        className="mb-2.5 text-s font-medium text-dark-primary-max"
        id={VOUCHER_SECTION_ID}
      >
        <FormattedMessage id="product.buyBox.voucherSectionHeading" />
      </h3>
      <Card>
        <CardContent className="bg-light-primary-low p-4">
          <div className="flex flex-col gap-3">
            <span>
              <ProductVoucherInteractiveLabel
                legalText={legalText}
                voucher={voucher}
              />
            </span>

            <p className="text-s font-normal text-dark-primary-max">
              {ctaText}
            </p>

            <ProductCopyVoucherButton voucher={voucher} />
          </div>
        </CardContent>
      </Card>
    </section>
  )
}
